import { Heading } from '@cognite/cogs.js-v10';
import styled from 'styled-components';

export const MessageContentWrapper = styled(Heading).attrs({ level: 6 })`
  display: inline-block;
  max-width: 100vw;
`;
